import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpRecommendedActionsBlock } from './CmsAmpRecommendedActionsBlock';
import { CmsRecommendedActionsBlock } from './CmsRecommendedActionsBlock';

export const CmsRecommendedActionsBlockMapping: CmsBlockMapping<CmsApiRecommendedActionsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsRecommendedActionsBlock,
    AmpComponent: CmsAmpRecommendedActionsBlock,
  };
